<template>
    <a :href="frontendUrl + link" target="_blank"
       class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-icon-primary font-weight-bolder px-5">
            <span class="svg-icon svg-icon-md">
                <i class="fas fa-eye"></i>
            </span>
        {{ __('general.view_on_youbuyda') }}
    </a>
</template>

<script>
export default {
    name: 'PreviewLink',

    props: {
        frontendUrl: String,
        link: String,
    },
}
</script>